import { Box } from '@mui/material'
import UserChatBubbleAttachmentChips from './UserChatBubbleAttachmentChips'
import UserChatBubbleMorphBubble from './UserChatBubbleMorphBubble'
import styles from './index.module.scss'

export function buildUserChatBubbleMorph({
  isEditing,
  attachments,
  attachmentState,
  gallery,
  draftText,
  onDraftTextChange,
  onCancelEdit,
  onSendEdit,
  replyTo,
  onJumpToQuotedMessage,
  children,
}) {
  const attachmentChips =
    !isEditing && attachments.length > 0 ? (
      <UserChatBubbleAttachmentChips
        {...attachmentState}
        openSentImageGallery={gallery.openSentImageGallery}
      />
    ) : null

  return (
    <Box className={styles.messageStack}>
      {attachmentChips}
      <UserChatBubbleMorphBubble
        isEditing={isEditing}
        draftText={draftText}
        onDraftTextChange={onDraftTextChange}
        onCancelEdit={onCancelEdit}
        onSendEdit={onSendEdit}
        replyTo={replyTo}
        onJumpToQuotedMessage={onJumpToQuotedMessage}
      >
        {children}
      </UserChatBubbleMorphBubble>
    </Box>
  )
}
